export const iconFontAwesomeCodingWindowMinimize = (
	<i className="fa-solid fa-window-minimize"></i>
);
